import { FiLock, FiPlus } from "react-icons/fi";
import useServiceStatus from "../../hooks/useServiceStatus";
import { useDispatch } from "react-redux";
import { openSideMenu } from "../../redux/ui/uiSlice";
import ActivateBotServiceModal from "./ActivateBotServiceModal";
import { useState } from "react";
import CreateBotMenu from "./create-bot/CreateBotMenu";

function CreateBot({ title, className }) {
  const { isActive: isBotActive } = useServiceStatus("bot");
  const [showServiceActivationModal, setShowServiceActivationModal] =
    useState(false);

  const dispatch = useDispatch();

  const clickHandler = () => {
    dispatch(openSideMenu("create-bot", "create-bot"));
    // if (isBotActive) {
    //   dispatch(openSideMenu("create-bot", "create-bot"));
    // } else {
    //   setShowServiceActivationModal(true);
    // }
  };

  return (
    <>
      <span className={className} onClick={clickHandler}>
        {/*{isBotActive ? <FiPlus /> : <FiLock />}*/}
        <FiPlus />
        {title || "Start New Bot"}
      </span>

      {showServiceActivationModal && (
        <ActivateBotServiceModal
          setShowActivationModal={setShowServiceActivationModal}
          showActivationModal={showServiceActivationModal}
        />
      )}

      <CreateBotMenu />
    </>
  );
}

export default CreateBot;
